import React, { Component } from "react";
import { push } from "../Services/Analytics"
import ReactCardFlip from 'react-card-flip';
import "./FlipItems.scss"

import dataJSON from "../../api/FlipPic.json"

class FlipItems extends Component {
    constructor(props) {
        super();
        this.state = {
            isFlipped: false
        }
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(e, label) {
        e.preventDefault();
        this.setState({
            isFlipped: !this.state.isFlipped
        });
        push("Flip_Picture_Clicked", label);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            isFlipped: false
        })
    }
    getItems() {
        return dataJSON.list.map((item, index) =>
            <PostItem key={index}
                index={index}
                handleClick={this.handleClick}
                isFlipped={this.state.isFlipped}
                current={this.props.current}
                goRefresh={this.state.refresh}
                labelA={item.label_A}
                labelB={item.label_B}
                flip_A={item.flip_A}
                flip_B={item.flip_B}
                item={item.flip} />
        )
    }
    render() {
        return (
            <div className="flip-container">
                {this.getItems()}
            </div>
        );
    }
}

const PostItem = (props) => {
    const imageA = {
        backgroundImage: `url(./static/images/flipped/${props.flip_A})`
    }
    const imageB = {
        backgroundImage: `url(./static/images/flipped/${props.flip_B})`
    }
    return (
        <div className={`flip-item${(props.current == props.index ? " active" : "")}`}>
            <ReactCardFlip isFlipped={props.isFlipped}>
                <div key="front" style={imageA} className="front" onClick={(event, label) => { props.handleClick(event, props.labelA) }}>

                    <div className={`button${(props.index == 0 ? " active" : "")}`}>
                        
                    </div>
                </div>
                <div key="back" style={imageB} className="back" onClick={(event, label) => { props.handleClick(event, props.labelA) }}>

                </div>
            </ReactCardFlip>
        </div>
    )
}

export default FlipItems;


// WEBPACK FOOTER //
// ./src/Components/FlipPic/FlipPic.items.js